import { useState } from "react";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { PageContent } from "@src/presentation/components/Layout/common";
import {
  PurchasersContent,
  PurchasersFooter,
  PurchasersHeader,
} from "./utils";
import type { PurchaserFormMode } from "./utils/purchaserFormUtils";

export const PAGE_LIMIT = 15;

const PurchasersPageContent = () => {
  const [formMode, setFormMode] = useState<PurchaserFormMode>(null);
  const [editingPurchaserId, setEditingPurchaserId] = useState<number | null>(null);

  const handleAddPurchaser = () => {
    setFormMode("add");
    setEditingPurchaserId(null);
  };

  const handleEditPurchaser = (purchaserId: number) => {
    setFormMode("edit");
    setEditingPurchaserId(purchaserId);
  };

  const handleCloseForm = () => {
    setFormMode(null);
    setEditingPurchaserId(null);
  };

  return (
    <>
      <PurchasersHeader
        onAddPurchaser={handleAddPurchaser}
        isAddPurchaserDisabled={formMode === "add"}
      />
      <PageContent className="p-4">
        <PurchasersContent
          formMode={formMode}
          editingPurchaserId={editingPurchaserId}
          onCloseForm={handleCloseForm}
          onEditPurchaser={handleEditPurchaser}
        />
      </PageContent>
      <PurchasersFooter />
    </>
  );
};

export const Purchasers = () => (
  <ErrorBoundary>
    <PurchasersPageContent />
  </ErrorBoundary>
);
